import { useState, useEffect } from 'react';
import { DataServiceHookResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useAuthorizationSelectedPayroll, useInitiatePayrollMandateService } from '../../../../contexts/Payroll/hooks';
import { InitiateMandateResponseBody } from '../../../../domain/Authorization/entities/InitiateMandateResponseDTO';

const usePayrollInitiateService = (
  authAction: Nullable<string>,
  cancellationReason?: string,
): DataServiceHookResponse<InitiateMandateResponseBody> => {
  const [timestamp, setTimestamp] = useState<Nullable<string>>(null);
  const selectedPayroll = useAuthorizationSelectedPayroll();
  const initiateMandateService = useInitiatePayrollMandateService()();

  const shouldInitiatePayroll =
    authAction !== null &&
    (Boolean(authAction === 'approve') || Boolean(authAction === 'reject' && Boolean(cancellationReason))) &&
    Boolean(timestamp);

  useEffect(() => {
    if (!timestamp) {
      setTimestamp(new Date().toISOString());
    }
  }, [timestamp]);

  return useInvokeSWRService<InitiateMandateResponseBody>(
    initiateMandateService,
    {
      appTransactionId: parseInt(selectedPayroll?.referenceNumber!),
      accepted: authAction === 'approve',
      cancellationReason,
      orderCode: selectedPayroll?.globalOrderId,
      meta: { timestamp },
    },
    shouldInitiatePayroll,
    'authorizationService.ExecuteMandate',
  );
};

export { usePayrollInitiateService };
